<template>
    <div class="response-modal-wrapper" v-if="isConfirmationModalOpen" @click="closeConfirmationModal">
        <div data-aos="fade-left" class="response-modal" @click.stop>
            <div class="response-header">
                <div class="response-title">
                    <p v-if="this.interested">Interesiert?</p>
                    <p v-else>Nicht Interesiert?</p>
                </div>

                <div @click="closeConfirmationModal" class="response-close-btn pointer">
                    <img alt="icon" src="../assets/icons/modal_close_icon.svg"/>
                </div>
            </div>

            <div class="response-info">
                <p v-if="this.interested">Sind Sie Sicher, Dass Sie Sich Für Diese Stelle Interessieren?</p>
                <p v-else>Sind Sie Sicher, Dass Sie Nicht An Diesem Stellenangebot Interessiert Sind?</p>
            </div>

            <div class="form-el">
                <textarea class="form-input" placeholder="Koment" rows="10" cols="50" v-model="comment"></textarea>
            </div>

            <div class="form-footer">
                <div class="footer-btn next-btn" @click="confirm"> 
                    <p v-if="!isResponding">JA</p>
                    <div v-else class="loader-wrapper">
                        <span class="loader"></span>
                    </div> 
                </div>

                <div class="footer-btn next-btn nein-btn" @click="closeConfirmationModal">
                    <p>NEIN</p> 
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    modalsComputed,
    modalsMethods,
    dashboardMethods,
    dashboardComputed,
} from "../store/helpers";
import Swal from 'sweetalert2';
import axiosInstance from "@/axios";

export default {
    computed: { 
        ...modalsComputed,
        ...dashboardComputed,
    },
    methods: {
        ...modalsMethods,
        ...dashboardMethods,

        closeConfirmationModal() {
            this.toggleConfirmationModal(false); 
            this.resetInterested();

            this.setUserUuidValue(null);
            this.setVacancyIdValue(null);
        },

        confirm() {
            if(this.interested){
                this.sendInterested();
            }else{
                this.sendNotInterested();
            } 
        },

        async sendInterested(){  
            this.isResponding = true; 
            await axiosInstance({ requiresAuth: true }).post(`/api/v1/portal/candidate-vacancies/${this.userUuid}/vacancies/${this.vacancyId}/gtg`, {comment:this.comment})
            .then(() => {                               
             
                let timerInterval;
                Swal.fire({
                    title: "Erfolgreich gesendet!",
                    timer: 1200,
                    timerProgressBar: true,
                    icon: "success",
                    showConfirmButton: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                        timerInterval = setInterval(() => {
                            Swal.getContent().querySelector("b").textContent =
                                Swal.getTimerLeft();
                            }, 100);
                        },
                        onClose: () => {
                            clearInterval(timerInterval);
                        },
                }).then(() => { 
                    try {
                        this.fetchDashboardData();
                        this.comment = '';
                        this.isResponding = false;  
                        this.closeConfirmationModal(); 
                    } catch (error) { 
                        const errorMessage = error.response && error.response.data && error.response.data.message 
                            ? error.response.data.message 
                            : "Ein unerwarteter Fehler ist aufgetreten.";

                        Swal.fire("Da ist etwas schiefgelaufen.", errorMessage, "warning").then(()=>{
                                this.comment = '';
                                this.isResponding = false;  
                                this.closeConfirmationModal(); 
                        })
                    }
                });
            })
            .catch(error => {
                const errorMessage = error.response && error.response.data && error.response.data.message 
                    ? error.response.data.message 
                    : "Ein unerwarteter Fehler ist aufgetreten.";
                    
                Swal.fire("Da ist etwas schiefgelaufen.", errorMessage, "warning").then(()=>{
                    this.isResponding = false;  
                });
            })
        },

        async sendNotInterested(){  
            this.isResponding = true;
            await axiosInstance({ requiresAuth: true }).post(`/api/v1/portal/candidate-vacancies/${this.userUuid}/vacancies/${this.vacancyId}/ngtg`, {comment:this.comment})
            .then(() => {                   
                let timerInterval;
                Swal.fire({
                    title: "Erfolgreich gesendet!",
                    timer: 1200,
                    timerProgressBar: true,
                    icon: "success",
                    showConfirmButton: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                        timerInterval = setInterval(() => {
                            Swal.getContent().querySelector("b").textContent =
                                Swal.getTimerLeft();
                            }, 100);
                        },
                        onClose: () => {
                            clearInterval(timerInterval);
                        },
                }).then(() => {
                    try {
                        this.fetchDashboardData();
                        this.comment = '';
                        this.isResponding = false;  
                        this.closeConfirmationModal(); 
                    } catch (error) { 
                        const errorMessage = error.response && error.response.data && error.response.data.message 
                            ? error.response.data.message 
                            : "Ein unerwarteter Fehler ist aufgetreten.";

                        Swal.fire("Da ist etwas schiefgelaufen.", errorMessage, "warning").then(()=>{
                                this.comment = '';
                                this.isResponding = false;  
                                this.closeConfirmationModal(); 
                        })
                    } 
                });     
            })
            .catch(error => {
                const errorMessage = error.response && error.response.data && error.response.data.message 
                    ? error.response.data.message 
                    : "Ein unerwarteter Fehler ist aufgetreten.";

                Swal.fire("Da ist etwas schiefgelaufen.", errorMessage, "warning").then(()=>{
                    this.isResponding = false; 
                });
            })
        },
    },
    data() {
        return {
            isResponding: false,
            comment: '',
        };
    },
};
</script>

<style scoped>
.loader {
    width: 30px !important;
    height: 30px !important;
    border: 4px solid white !important;
    border-bottom-color: transparent !important;
}
</style>
